import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "./PrivateRoute";
import Login from "../components/auth/Login";
import ForgetPassword from "../components/auth/ForgetPassword";
import ResetPassword from "../components/auth/ResetPassword";
import HandleGoogleRedirect from "../components/auth/HandleGooglRedirect";
import { getAccess } from "../helpers/ReduxHelpers";

// Component for conditional redirect based on user access
function ConditionalRedirect() {
  try {
    const accessList = getAccess();
    const hasB2CAccess = accessList.includes("B2C_ACCESS");

    return <Navigate to="/home" />;
  } catch (error) {
    console.warn("Error checking user access, defaulting to home:", error);
    return <Navigate to="/home" />;
  }
}

export default function AppRoutes() {
  const { userInfo } = useSelector((state) => state.user);
  let isAuthorized = userInfo?.accessToken || false;

  return (
    <BrowserRouter>
      <Routes>
        <Route>
          {/* <Route path='logout' element={<Logout />} /> */}
          {isAuthorized ? (
            <>
              <Route path="/*" element={<PrivateRoutes />} />
              <Route index element={<ConditionalRedirect />} />
            </>
          ) : (
            <>
              <Route
                exact
                element={<ForgetPassword />}
                path="/forgot-password"
              />
              <Route exact element={<ResetPassword />} path="/reset-password" />
              <Route path="auth/*" element={<Login />} />
              <Route path="*" element={<Navigate to="auth/login" />} />
              <Route
                path="google/redirect_uri"
                element={<HandleGoogleRedirect />}
              />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
